import { http, HttpResponse } from 'msw'

import { CardApiModelStub } from '@webapp/modules/spending-cards/data-access/api-models/stubs/CardApiModel.stub'
import { getResponseObject } from '@webapp/tests/getResponseObject'

export const mockGetRequestableCardsSuccess = (
  cardStubs = CardApiModelStub.buildList(1)
) => {
  return http.get(
    `/api/v3/pay/cards/requestable/`,
    () => {
      return HttpResponse.json(getResponseObject(cardStubs), { status: 200 })
    },
    { once: true }
  )
}

export const mockGetRequestableCardsError = () => {
  return http.get(
    `/api/v3/pay/cards/requestable/`,
    () => {
      return new HttpResponse(null, { status: 400 })
    },
    { once: true }
  )
}
